export default {
    slideStates: {
        1.1: [],
        1.2: [],
        2.1: [],
        2.2: [],
        2.3: [],
        2.4: []
    },
    progress: {
        1.1: {
            slide: 0,
            finished: false
        },
        1.2: {
            slide: 0,
            finished: false
        },
        2.1: {
            slide: 0,
            finished: false
        },
        2.2: {
            slide: 0,
            finished: false
        },
        2.3: {
            slide: 0,
            finished: false
        },
        2.4: {
            slide: 0,
            finished: false
        }
    },
    tutorialOffered: false
};
